/**
 * !!! AUTOGENERATED, DO NOT MODIFY !!!
 *
 * This file is gitignored and regenerated by
 * script/remote_lookup/update-ignored-files.ts via `yarn update-generated-files`.
 *
 * @owner @Appboy/messaging-experience
 */
import { appProvider } from "../providers/appProvider";
import { campaignProvider } from "../providers/campaignProvider";
import { canvasProvider } from "../providers/canvasProvider";
import { canvasStepProvider } from "../providers/canvasStepProvider";
import { cohortProvider } from "../providers/cohortProvider";
import { csvImportProvider } from "../providers/csvImportProvider";
import { customAttributeProvider } from "../providers/customAttributeProvider";
import { customEventProvider } from "../providers/customEventProvider";
import { developerProvider } from "../providers/developerProvider";
import { purchaseProvider } from "../providers/purchaseProvider";
import { segmentCohortProvider } from "../providers/segmentCohortProvider";
import { sparseSegmentProvider } from "../providers/sparseSegmentProvider";
import { tagProvider } from "../providers/tagProvider";
import { territoryProvider } from "../providers/territoryProvider";

export const providers = {
  app: appProvider,
  campaign: campaignProvider,
  canvas: canvasProvider,
  canvas_step: canvasStepProvider,
  cohort: cohortProvider,
  csv_import: csvImportProvider,
  custom_attribute: customAttributeProvider,
  custom_event: customEventProvider,
  developer: developerProvider,
  purchase: purchaseProvider,
  segment_cohort: segmentCohortProvider,
  sparse_segment: sparseSegmentProvider,
  tag: tagProvider,
  territory: territoryProvider,
} as const;
